<template>
    <div>
        <template v-if="!isPasswordCreation && !modifyPassword">
            <div class="d-flex justify-content-between p-3 bg-light align-items-center" :class="{'border border-danger': errorMessage}">
                <div>
                    ************
                </div>
                <a class="d-block cursor-pointer" @click="modifyPassword = true;">
                    <i class="fal fa-pen mr-1"></i>
                    Modifier
                </a>
            </div>
        </template>
        <template v-else>
            <div :class="{'p-3 bg-light' : showOldPasswordInput}">
                <div v-if="showOldPasswordInput" class="mb-3 align-items-center">
                    <div class="row">
                        <div class="col">
                            <h6 class="font-weight-bold mb-0">
                                Mot de passe actuel
                            </h6>
                            <div class="d-flex mt-1">
                                <input v-model="oldPassword" autocomplete="old-password" placeholder="Saisissez" :type="showPlainOldPassword ? 'text' : 'password'" class="form-control" :class="{'is-invalid' : errorMessage}" name="old_password">
                                <a class="d-block ml-2 my-auto cursor-pointer text-center" style="width: 20px;" @click="showPlainOldPassword = !showPlainOldPassword;">
                                    <i class="fal" :class="showPlainOldPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <h6 v-if="showOldPasswordInput" class="font-weight-bold">
                    Nouveau mot de passe
                </h6>
                <div class="d-flex align-items-center">
                    <input v-model="password" autocomplete="new-password" placeholder="Saisissez" :type="showPlainPassword ? 'text' : 'password'" class="form-control" :class="{'is-invalid' : errorMessage}" :name="name">
                    <a class="d-block ml-2 cursor-pointer text-center" style="width: 20px;" @click="showPlainPassword = !showPlainPassword;">
                        <i class="fal" :class="showPlainPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </a>
                </div>
                <div v-if="password.length > 0 && showPasswordValidation" class="mt-3">
                    <div class="row form-group mt-1">
                        <div class="col">
                            <div>
                                Votre mot de passe doit contenir :
                            </div>
                            <div>
                                <i
                                    id="icon-password-charactercount"
                                    class="fa fa-circle-check"
                                    :class="password.length > 7 ? 'text-success' : 'text-muted'"
                                ></i>
                                8 caractères minimum
                            </div>
                            <div>
                                <i
                                    id="icon-password-characteruppercase"
                                    class="fa fa-circle-check"
                                    :class="password.match(/[A-Z]/) ? 'text-success' : 'text-muted'"
                                ></i>
                                Une majuscule
                            </div>
                            <div>
                                <i
                                    id="icon-password-number"
                                    class="fa fa-circle-check"
                                    :class="password.match(/\d/) ? 'text-success' : 'text-muted'"
                                ></i>
                                Un chiffre
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showOldPasswordInput" class="text-right mt-3">
                    <a class="btn hub-btn-outline-medium-grey ml-2 cursor-pointer" @click="modifyPassword = false;">
                        Annuler
                    </a>
                </div>
            </div>
        </template>
        <template v-if="errorMessage">
            <div class="text-danger">
                <strong>{{ errorMessage }}</strong>
            </div>
        </template>
    </div>
</template>


<script>
export default {
    props: {
        errorMessage: {
            type: String,
            default: null,
        },
        isPasswordCreation: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: 'password',
        },
        showPasswordValidation: {
            type: Boolean,
            default: true,
        },
        showOldPasswordInput: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            password: '',
            oldPassword: '',
            modifyPassword: false,
            showPlainPassword: false,
            showPlainOldPassword: false,
        };
    },
};
</script>
